const DEFAULT_WEBHOOK_URL = 'https://apilive.victione.com:5678/webhook/ticket-chat';

export function getOrCreateSessionId(sessionKey = 'ai_chat_session_id') {
  let sid = localStorage.getItem(sessionKey);
  if (!sid) {
    sid = `user_${Math.random().toString(36).slice(2, 10)}_${Date.now()}`;
    localStorage.setItem(sessionKey, sid);
  }
  return sid;
}

export function resetSessionId(sessionKey = 'ai_chat_session_id') {
  const sid = `user_${Math.random().toString(36).slice(2, 10)}_${Date.now()}`;
  localStorage.setItem(sessionKey, sid);
  return sid;
}

/**
 * POST to n8n ticket-chat webhook.
 * @returns {Promise<string>} AI answer text
 */
export async function sendTicketChatMessage({
  message,
  sessionId,
  webhookUrl = DEFAULT_WEBHOOK_URL,
  extraBody = {},
}) {
  const res = await fetch(webhookUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      message,
      session_id: sessionId,
      ...extraBody,
    }),
  });

  if (!res.ok) {
    throw new Error(`Server error: ${res.status}`);
  }

  const data = await res.json();
  return data.answer || data.response || data.message || 'Sorry, I could not understand that.';
}

export { DEFAULT_WEBHOOK_URL };
